import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const RkMonitoringConfig = React.lazy(async () => ({
    default: (await import('@oc/rk-monitoring-config/module')).RkMonitoringConfig
}))

export function RkMonitoringConfigComponent() {
    return <SuspenseWhileLoading LazyComponent={RkMonitoringConfig} />
}
